import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { DeleteLearnerDto } from "src/app/_models/DeleteLearnerDto";
import { LearnerList } from "src/app/_models/LearnerList";
import { UpdateLearnerTableDto } from "src/app/_models/UpdateLearnerTableDto";
import { UpdateStatusDto } from "src/app/_models/UpdateStatusDto";
import { LearnerActionTypes } from "src/app/constants/StoreConstants";

export const ResetLearnerState = createAction(LearnerActionTypes.ResetLearnerState);

export const GetLearnerTable = createAction(
    LearnerActionTypes.GetLearnerTable,
    props<{ pageNumber: number; isInitialLoad: boolean, isFromTutorPage: boolean }>()
);

export const GetLearnerTableSuccess = createAction(
    LearnerActionTypes.GetLearnerTableSuccess,
    props<{ result: LearnerList[] }>()
);

export const GetLearnerTableError = createAction(
    LearnerActionTypes.GetLearnerTableError,
    props<{ learnerTableError: HttpErrorResponse }>()
);

export const GetLearnerTableLength = createAction(
    LearnerActionTypes.GetLearnerTableLength
);

export const GetLearnerTableLengthSuccess = createAction(
    LearnerActionTypes.GetLearnerTableLengthSuccess,
    props<{ length: number }>()
);

export const GetLearnerTableLengthError = createAction(
    LearnerActionTypes.GetLearnerTableLengthError,
    props<{ error: any }>()
);

export const UpdateLearnerTable = createAction(
    LearnerActionTypes.UpdateLearnerTable,
    props<{ params: UpdateLearnerTableDto, isFromTutorPage: boolean }>()
);

export const UpdateLearnerTableError = createAction(
    LearnerActionTypes.UpdateLearnerTableError,
    props<{ error: any }>()
);
export const ResetLearnerTable = createAction(
    LearnerActionTypes.ResetLearnerTable,
    props<{ isInitialLoad: boolean }>()
);

export const ResetLearnerTableSuccess = createAction(
    LearnerActionTypes.ResetLearnerTableSuccess,
    props<{ isInitialLoad: boolean }>()
);

export const ResetLearnerTableError = createAction(
    LearnerActionTypes.ResetLearnerTableError,
    props<{ error: any }>()
);

export const UpdateStatus = createAction(
    LearnerActionTypes.UpdateStatus,
    props<{ params: UpdateStatusDto[] }>()
  );
  
  export const UpdateStatusSuccess = createAction(
    LearnerActionTypes.UpdateStatusSuccess,
    props<{ isUpdatedSuccessFully: boolean }>()
  );
  
  export const UpdateStatusError = createAction(
    LearnerActionTypes.UpdateStatusError,
    props<{ error: any }>()
  );

  export const GetCurrentPageNumber = createAction(
    LearnerActionTypes.GetCurrentPageNumber,
    props<{ pageIndex: number }>()
  );

  export const GetCurrentPageNumberSuccess = createAction(
    LearnerActionTypes.GetCurrentPageNumberSuccess,
    props<{ currentPageNumber: number }>()
  );

  export const GetCurrentPageNumberError = createAction(
    LearnerActionTypes.GetCurrentPageNumberError,
    props<{ error: any }>()
  );

export const GetGroupLearnerCount = createAction(
    LearnerActionTypes.GetGroupLearnerCount
);

export const GetGroupLearnerCountSuccess = createAction(
    LearnerActionTypes.GetGroupLearnerCountSuccess,
    props<{ result: string }>()
);

export const GetGroupLearnerCountError = createAction(
    LearnerActionTypes.GetGroupLearnerCountError,
    props<{ error: HttpErrorResponse }>()
);

export const DeleteLearners = createAction(
    LearnerActionTypes.DeleteLearners,
    props<{ params: DeleteLearnerDto[]}>()
  );

  export const DeleteLearnersSuccess = createAction(
    LearnerActionTypes.DeleteLearnersSuccess,
    props<{ isDeletedSuccessFully: boolean }>()
  );

  export const DeleteLearnersError = createAction(
    LearnerActionTypes.DeleteLearnersError,
    props<{ error: any }>()
  );

  export const SetMultipleLearnerIds = createAction(
    LearnerActionTypes.SetMultipleLearnerIds,
    props<{learnerIds: number[]}>()
  );
  
  export const SetMultipleLearnerIdsSuccess = createAction(
    LearnerActionTypes.SetMultipleLearnerIdsSuccess
  );